module.exports = flarum.core.compat['helpers/fullTime'];